import React, { useState } from "react";
import styles from "./index.module.css";
import { HeroImage } from "../../assets";
import GlowButton from "../GlowButton";
import Glow from "../../Components/Glow";
import { Sparkels } from "..";

const Hero = (props) => {

  const [mail, setMail] = useState('');

  return (
      <section className={`${styles.container} relative w-[100vw] h-[35vh]`}>
          <img
            className="absolute object-cover w-[100vw] h-[100vh]"
            src={HeroImage}
            alt="Chess Cloud Analysis Platform"
          />

        <div className="relative float-left mt-[70px] sm:mt-[120px] min-w-[350px] w-full md:w-[60%] px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
          <div className="max-w-xl mx-auto text-center">
          <h3 className={`${styles.title}`}>
          Free Chess
          <br />
          Analysis Platform
        </h3>
        <Sparkels />
            <p className="max-w-[100%] mx-auto mt-0 text-base font-normal md:text-gray-100 text-white mix-blend-difference md:mix-blend-normal leading-7 tracking-[2px] font-bold md:font-thin">
              Chessmind is a free chess platform that delivers chess analysis with built in strong cloud engines. Experience deep analysis with Stockfish engines reaching the highest speeds. Build your own chess book with our new way of writing chess moves and enjoy our evaluations and games database - all for free.
            </p>
            <h1 className="font-bold text-white"> Enjoy a Free Trail No Credit Card Required !</h1>
            
            <div className={`flex ${props.width < 900 && 'flex-col'} mt-[30px] items-center justify-center`}>
              <div className="flex-1">
                <label htmlFor="" className="sr-only">
                  {" "}
                  Email address{" "}
                </label>
                <div>
                  <input
                    type="email"
                    name=""
                    id=""
                    value={mail}
                    onChange={(e) => setMail(e.target.value)}
                    className="block w-full px-4 py-3.5 text-base font-medium text-gray-900 placeholder-gray-500 border border-gray-300 min-w-[250px] rounded-lg sm:text-sm focus:ring-gray-900 focus:border-gray-900"
                    placeholder="Email address"
                  />
                </div>
              </div>
            
              <div className="relative group">
                <div className="absolute transitiona-all duration-1000 opacity-70 inset-0 bg-gradient-to-r from-[#44BCFF] via-[#FF44EC] to-[#FF675E] rounded-xl blur-lg filter group-hover:opacity-100 group-hover:duration-200"></div>

                <GlowButton onClick={(e) => {
                  e.preventDefault();
                  window.location.href = '/register?mail=' + mail;
                }} text="Get Started Now" />
              </div>
              </div>

            <ul className={` flex items-center justify-center mt-6 space-x-6 sm:space-x-8 min-w-[${props.width < 620 ? '350px' : '400px'}]`}>
              <li className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#51c8eb"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-xs font-medium text-gray-100 sm:text-sm max-w-[200px]">
                  {" "}
                  Strongest Chess Engines{" "}
                </span>
              </li>

              <li className="flex items-center">
                <svg
                  className="w-5 h-5 mr-2 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="#51c8eb"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span className="text-xs font-medium text-gray-100 sm:text-sm max-w-[180px]">
                  {" "}
                  Best prices on the market{" "}
                </span>
              </li>
            </ul>
          </div>
        </div>
        <Glow width={props.width} />
      </section>
  );
};

export default Hero;
